export enum EBenefit {
  PEJOTAPLUS = 'pejotaplus',
  APPMAX = 'appmax',
  ZENDROP = 'zendrop',
}
